import lodash from "lodash";


export function removeTypename(obj: any): any{

  if(!obj){
    return {}
  }

  if(lodash.isArray(obj)){
    return obj?.map((item) => removeTypename(item))
  }

  if(lodash.isString(obj)){
    return obj;
  }

  return lodash.chain(obj)
    .entries()
    .filter(([key,]) => key !== "__typename")
    .map(([key, innerVal]) => ([
      key,
      removeTypename(innerVal)
    ]))
    .fromPairs()
    .value()
}